import Icon from 'src/components/ui/Icon.vue'
import UIButton from 'src/components/ui/UIButton.vue'
import AppLink from 'src/components/AppLink.vue'
import Counter from 'src/components/ui/Counter.vue'
import CustomModal from 'src/core/components/customModal/CustomModal.vue'

export default ({ app }) => {
  // eslint-disable-next-line vue/multi-word-component-names
  app.component('Icon', Icon)
  app.component('UIButton', UIButton)
  app.component('AppLink', AppLink)
  // eslint-disable-next-line vue/multi-word-component-names
  app.component('Counter', Counter)
  app.component('CustomModal', CustomModal)
}
